import { render, staticRenderFns } from "./VCPdfReportChallenge.vue?vue&type=template&id=2ddd8164&scoped=true"
import script from "./VCPdfReportChallenge.vue?vue&type=script&lang=js"
export * from "./VCPdfReportChallenge.vue?vue&type=script&lang=js"
import style0 from "./VCPdfReportChallenge.vue?vue&type=style&index=0&id=2ddd8164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddd8164",
  null
  
)

export default component.exports